const DATES_AVAILABILITY = {
  title: 'Gestor de Pedidos',
  greetings: {
    title: 'Olá,',
    subtitle:
      'Aqui você pode selecionar as datas em que a sua loja não está disponível para a venda de Chopp',
  },
  datesAvailability: {
    title:
      'Selecione as datas que você deseja que sua loja não esteja disponível para venda no app do Zé Delivery',
    subtitle: 'Seleção de Datas Indisponíveis',
    clearButtonLabel: 'Limpar Datas Indisponiveis',
    saveButtonLabel: 'Salvar',
  },
  buttons: {
    clearDates: 'Limpar Datas Indisponíveis',
    saveDates: 'Salvar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Salvar',
  },
  modals: {
    confirmDates: {
      title: 'Porque você vai bloquear essa janela de entrega?',
      subtitle: 'Descreva o motivo com o máximo de detalhes.',
    },
    clearDates: {
      title: 'Tem certeza que deseja resetar as datas bloqueadas?',
      subtitle: 'Essa ação não poderá ser desfeita.',
    },
  },
  toastMessages: {
    success: 'Janela de bloqueio atualizada',
    error: 'Ops! Ocorreu um erro ao atualizar janela',
  },
  drawerAvailabilityControl: {
    title: 'Editar disponibilidade',
    currentStatusLabel: 'Status atual:',
    currentStatusByDate: {
      AVAILABLE: 'Dia Inteiro Livre',
      MORNING_CLOSED: 'Manhã bloqueada',
      AFTERNOON_CLOSED: 'Tarde bloqueada',
      FULL_DAY_CLOSED: 'Dia Inteiro Bloqueado',
    },
    subtitle: 'Alterar para',
    morning: 'Bloquear manhã (10h - 14h)',
    afternoon: 'Bloquear tarde (14h - 18h)',
    fullDay: 'Bloquear dia inteiro (10h - 18h)',
    selectedMorning: 'Liberar manhã (10h - 14h)',
    selectedAfternoon: 'Liberar tarde (14h - 18h)',
    selectedFullDay: 'Liberar dia inteiro (10h - 18h)',
    descriptionLabel:
      'Descreva com o máximo de detalhes o motivo do bloqueio dessa janela de entrega',
  },
}

export default DATES_AVAILABILITY
